(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["follow-us"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    var koviSwiper = new Swiper('.kovi-swiper-container', {
      // Optional parameters
      loop: true,
      slidesPerView: 5,
      spaceBetween: 20,
      // ... other parameters ...

      // Unique Pagination and Navigation
      pagination: {
        el: '.kovi-swiper-pagination',
        dynamicBullets: true,
        clickable: true
      },
      navigation: {
        nextEl: '.kovi-swiper-button-next',
        prevEl: '.kovi-swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-extension-collections-info"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {


     var observer;
  var navContainer = document.querySelector('.mobile-info-nav-container');
  var targetSection = document.getElementById('hair-extenions-info-container'); // Note the typo in your ID. It should match exactly.

  var options = {
    root: null, // observes intersections relative to the viewport
    threshold: 0.35, // trigger callback when targetSection is fully in the viewport
    rootMargin: '0px' // margin around the root. Can be values like '10px' or '-10%' to grow or shrink each side of the root's bounding box before computing intersections
  };

  var callback = function(entries, observer) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        // Add sticky class or style when the targetSection enters the viewport
        navContainer.style.display = 'block';
        navContainer.style.position = 'fixed';
        navContainer.style.top = '0';
        navContainer.style.width = '100%';
        navContainer.style.zIndex = '1000'; // Ensure it stays on top of other content
      } else {
        // Remove sticky class or style when the targetSection leaves the viewport
        navContainer.style.display = 'none';
        navContainer.style.position = '';
        navContainer.style.top = '';
        navContainer.style.width = '';
        navContainer.style.zIndex = ''; // Reset to default
      }
    });
  };

  observer = new IntersectionObserver(callback, options);
  observer.observe(targetSection);

  
    var menuItemsDesktop = document.querySelectorAll('#menu li');
    var customSelectWrapper = document.querySelector('.custom-select-wrapper');
    var customOptions = document.querySelectorAll('.custom-option');
    var contentSections = document.querySelectorAll('.content-section');

    function changeActiveSection(targetId) {
        // Hide all sections
        contentSections.forEach(function(section) {
            section.style.display = 'none';
        });

        // Show the targeted section
        var activeSection = document.getElementById(targetId);
        if (activeSection) {
            activeSection.style.display = 'flex'; // Changed to 'block' to ensure compatibility with different layouts
        }

        // Update active menu item for both desktop and custom dropdown
        updateActiveMenuItem(targetId);
    }

    function updateActiveMenuItem(targetId) {
        menuItemsDesktop.forEach(function(item) {
            if (item.dataset.target === targetId) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        // Update the custom dropdown selection
        customOptions.forEach(function(option) {
            if (option.dataset.value === targetId) {
                customSelectWrapper.querySelector('.custom-select__trigger span').textContent = option.textContent;
                option.classList.add('selected');
            } else {
                option.classList.remove('selected');
            }
        });
    }

    // Desktop menu click event
    document.querySelector('#menu').addEventListener('click', function(event) {
        if (event.target.tagName === 'LI') {
            var targetId = event.target.dataset.target;
            changeActiveSection(targetId);
        }
    });

    // Custom dropdown option click event
    customOptions.forEach(function(option) {
        option.addEventListener('click', function() {
            var targetId = this.dataset.value;
            changeActiveSection(targetId);
        });
    });

    // Initialize the first section as active
    if (menuItemsDesktop.length > 0) {
        var initialTargetId = menuItemsDesktop[0].dataset.target;
        changeActiveSection(initialTargetId);
    }
});

  document.querySelectorAll('.custom-option').forEach(option => {
    option.addEventListener('click', function(e) {
        e.stopPropagation(); // Stop the event from propagating to the window
        if (!this.classList.contains('selected')) {
            let parent = this.closest('.custom-select');
            parent.querySelector('.custom-select__trigger span').textContent = this.textContent;
            parent.querySelector('.custom-option.selected').classList.remove('selected');
            this.classList.add('selected');
            parent.classList.remove('open');
        }
    })
});

window.addEventListener('click', function(e) {
    const select = document.querySelector('.custom-select')
    if (!select.contains(e.target)) {
        select.classList.remove('open');
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-extension-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".faq-question").forEach((item) => {
    item.addEventListener("click", () => {
      const answer = item.nextElementSibling;
      item.classList.toggle("open");
      // Adjust max-height based on the scrollHeight of the answer content
      if (item.classList.contains("open")) {
        answer.style.maxHeight = item.classList.contains("open") ? (answer.scrollHeight + 20) + "px" : "0";
      } else {
        answer.style.maxHeight = null;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
